import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { BrandActions } from "../actions";
import { BrandService } from "../services";

@Injectable()
export class BrandEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly brandService: BrandService
  ) {}

  brandGetList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BrandActions.brandGetList),
      switchMap(() =>
        this.brandService.brandGetList().pipe(
          mergeMap((_) => [BrandActions.brandGetListSuccess({ brands: _ })]),
          catchError((_) => [
            BrandActions.brandGetListFailure({ error: _.message })
          ])
        )
      )
    )
  );
}
